"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateDbScoreConfigSafe = exports.validateDbScoreConfig = exports.filterAndValidateDbScoreConfigList = void 0;
const score_configs_1 = require("../../domain/score-configs");
/**
 * Use this function when pulling a list of score configs from the database before using in the application to ensure type safety.
 * All score configs are expected to pass the validation. If a score fails validation, it will be logged to Otel.
 * @param scoreConfigs
 * @returns list of validated score configs
 */
const filterAndValidateDbScoreConfigList = (scoreConfigs, onParseError) => scoreConfigs.reduce((acc, ts) => {
    const result = score_configs_1.ScoreConfigSchema.safeParse(ts);
    if (result.success) {
        acc.push(result.data);
    }
    else {
        onParseError?.(result.error);
    }
    return acc;
}, []);
exports.filterAndValidateDbScoreConfigList = filterAndValidateDbScoreConfigList;
/**
 * Use this function when pulling a single score config from the database before using in the application to ensure type safety.
 * The score is expected to pass the validation. If a score fails validation, an error will be thrown.
 * @param scoreConfig
 * @returns validated score config
 * @throws error if score fails validation
 */
const validateDbScoreConfig = (scoreConfig) => score_configs_1.ScoreConfigSchema.parse(scoreConfig);
exports.validateDbScoreConfig = validateDbScoreConfig;
/**
 * Use this function when pulling a single score config from the database before using in the application to ensure type safety.
 * This function will NOT throw an error by default. The score is expected to pass the validation.
 * @param scoreConfig
 * @returns score config validation object:
 * - success: true if the score config passes validation
 * - data: the validated score config if success is true
 * - error: the error object if success is false
 */
const validateDbScoreConfigSafe = (scoreConfig) => score_configs_1.ScoreConfigSchema.safeParse(scoreConfig);
exports.validateDbScoreConfigSafe = validateDbScoreConfigSafe;
